import { Slice } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

import PageHandler from "./PageHandler";
import { useSiteMetadata } from "../hooks/useSiteMetadata";

const Layout = (props) => {
	const { children, location } = props;
	const { title } = useSiteMetadata();

	return (
		<>
			<PageHandler location={location} />
			<Slice alias="header" siteTitle={title} />
			<main>{children}</main>
			<Slice alias="footer" />
		</>
	);
};

Layout.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Layout;
